define('views/components/store_basket/store_basket',['require','backbone','text!templates/components/store_basket/store_basket.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/store_basket/store_basket.html");
    return Backbone.Marionette.LayoutView.extend({
        tagName: 'div',
        template: _.template(temp),

        initialize: function () {
            this.listenTo(App.vent, 'basket-updated', this._onBasketUpdate);
        },

        ui: function() {
            return {
                checkoutButton: '.checkout-button',
                removeProductIcon: '.remove-product'
            };
        },

        events: {
            'click @ui.checkoutButton': 'checkoutButtonClicked',
            'click @ui.removeProductIcon': 'removeProductIconClicked'
        },

        templateHelpers: function(){
            return {
                totalPrice: App.context.basket.get('products').reduce( function(total, currentProduct){
                    var dollar_try = parseFloat(App.context.constants.dollar_try);

                    if (App.utils.getPricingMode() == 'TRY' || App.utils.getPricingMode() == 'TRY_VAT') {
                        // Show TRY price
                        if (currentProduct.product.exchange_currency === 3) {
                            // Price set in TRY, add directly
                            return total + currentProduct.product.effective_price * currentProduct.count;
                        } else {
                            // Price set in USD, convert
                            return total + (currentProduct.product.effective_price * dollar_try * currentProduct.count);
                        }
                    } else {
                        // Show USD price
                        if (currentProduct.product.exchange_currency === 3) {
                            // Price set in TRY, convert
                            return total + ((currentProduct.product.effective_price / dollar_try) * currentProduct.count);
                        } else {
                            // Price set in USD, add directly
                            return total + currentProduct.product.effective_price * currentProduct.count;
                        }
                    }
                }, 0)
            };
        },

        removeProductIconClicked: function (e) {
            var currentTarget = $(e.currentTarget);
            var productId = parseInt(currentTarget.closest('.product-line').attr('data-product-id'));
            var licenseId = parseInt(currentTarget.closest('.product-line').attr('data-license-id'));

            var currentBasketProduct = App.context.basket.get('products').filter(function (basketProduct) {
                if (licenseId == '-1') {
                    return basketProduct.product.id == productId && !basketProduct.license;
                } else {
                    return basketProduct.product.id == productId && basketProduct.license == licenseId;
                }
            })[0];

            if (currentBasketProduct) {
                App.context.basket.get('products').splice(App.context.basket.get('products').indexOf(currentBasketProduct), 1);

                App.vent.trigger('basket-updated');
            }
        },

        checkoutButtonClicked: function () {
            
        },

        _onBasketUpdate: function () {
            this.render();
        }
    });
});
